import { render, staticRenderFns } from "./UserSignup.vue?vue&type=template&id=1da21f46&scoped=true&"
import script from "./UserSignup.vue?vue&type=script&lang=js&"
export * from "./UserSignup.vue?vue&type=script&lang=js&"
import style0 from "./UserSignup.vue?vue&type=style&index=0&id=1da21f46&prod&lang=scss&scoped=true&"
import style1 from "./UserSignup.vue?vue&type=style&index=1&id=1da21f46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da21f46",
  null
  
)

export default component.exports